export default __webpack_public_path__ + "static/media/girl_1.a702cd32.jpg";